import AvatarList from './AvatarList'

export default AvatarList
